import {BaseService} from "./BaseService";
import {Reader} from "../entities/Reader";
import { StateService } from "@uirouter/angularjs";

export class ReaderService extends BaseService<Reader>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, Reader);
    }
    protected getBaseUrl():string{
        return "reader";
    }
    public getServerReaders(){
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"server", config);
    }
    public GetGatewaysByService(serviceName:string){
        var config:any = {};
        return this.useBaseGetArrayHandler("gateways","service?serviceName="+serviceName, config);
    }
    public getGateways(){
        var config:any = {};
        return this.useBaseGetArrayHandler("gateways","", config);
    }
    public getByName(name:string){
        var config:any = {};
      // Modified 022519 by BA to put name as a query parameter to handle special characters (# and %)
      return this.useBaseGetHandler(this.getBaseUrl(),"name?name="+ encodeURIComponent(name), config);
    }
    public updateConnectionStatus(readerId:string,up:boolean){
        var config:any = {};
        return this.useGetHandler(this.getBaseUrl(),"updateConnectionStatus?readerId="+readerId+"&up="+up, config);
    }
    public getAllByService(serviceName:string){
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"service?serviceName="+serviceName, config);
    }
    public getBySite(mapSiteId:number):ng.IPromise<Reader[]>{
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"site?siteId="+mapSiteId, {});
    }
    public getChangedBySite(mapSiteId:number, lastChecked:string):ng.IPromise<Reader[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"changed?siteId="+mapSiteId+"&lastChecked="+lastChecked, config);
    }
}
